import { Component, Injector, OnDestroy, Input } from '@angular/core';

import { BaseFormComponent } from '../base-form.component';

@Component({
  moduleId: module.id,
  selector: 'text-date-short',
  templateUrl: './text-date-short.component.html',
})
export class TextDateShortComponent extends BaseFormComponent {
  @Input() mask = {
    guide: true,
    mask: [/^([0-1])/, /\d/, '/', /^(1|2)/, /^(9|0|1)/, /\d/, /\d/],
    placeholder: 'MM/YYYY',
  };
  dateProperty: string;

  constructor(protected injector: Injector) {
    super(injector);
    this.questionItem = this.injector.get('questionItem');

    this.dateProperty = this.questionItem.prop;

    this.updateFromModel();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  updateFromModel() {}

  resetValue() {}
}
